// extracted by mini-css-extract-plugin
export default {"criteriaModalList":"evaluation-form_criteriaModalList__uf6hM"};